import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { ToasterService } from "../../../services/toaster/toaster.service";
import { hallsAPI } from "../api/api";
import { HallsActionTypes } from "../actions/actionTypes";
import { push } from "react-router-redux";

function* deleteHall(action) {
    try {
        const hallID = action.payload.hallId;
        yield call(() => hallsAPI.deleteHall(hallID));
        yield put(push("/halls/"));
        ToasterService.successToast("Hall successfully deleted.");
    } catch (e) {
        API.handleError(e.response, "Error deleting hall.");
    }
}

export function* deleteHallWatcher() {
    yield takeLatest(HallsActionTypes.DELETE_HALL, deleteHall);
}
